import React, { useState } from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, elevation, motion } from '../tokens';

const URGENCY_STYLES = {
  now:    { color: colors.error,   label: 'Do now' },
  soon:   { color: colors.warning, label: 'Soon' },
  later:  { color: colors.info,    label: 'Later' },
};

const NextBestActionCard = ({
  action,
  onPrimary,
  onSecondary,
}) => {
  const [expanded, setExpanded] = useState(false);
  if (!action) return null;
  const urgency = URGENCY_STYLES[action.urgency] || URGENCY_STYLES.soon;

  return (
    <div
      style={{
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderLeft: `3px solid ${urgency.color}`,
        borderRadius: radius.md,
        padding: space[4],
        boxShadow: elevation.card,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: space[2],
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: space[2] }}>
          <Icon
            category="utility"
            name="apex_plugin"
            size="x-small"
            style={{ fill: urgency.color }}
          />
          <span style={{ ...type.label, color: urgency.color, letterSpacing: 0.6 }}>
            Next best action · {urgency.label}
          </span>
        </div>
      </div>

      <h4 style={{ ...type.h3, color: colors.textPrimary, margin: 0, marginBottom: space[2] }}>
        {action.title}
      </h4>

      <p style={{
        ...type.small,
        color: colors.textSecondary,
        margin: 0,
        marginBottom: space[3],
        lineHeight: 1.5,
        maxHeight: expanded ? 'none' : 48,
        overflow: 'hidden',
        position: 'relative',
      }}>
        {action.rationale}
      </p>

      {action.rationale && action.rationale.length > 90 && (
        <button
          onClick={() => setExpanded(!expanded)}
          style={{
            background: 'transparent',
            border: 'none',
            padding: 0,
            marginBottom: space[3],
            ...type.micro,
            color: colors.brand,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
          }}
        >
          {expanded ? 'Show less' : 'Why this?'}
        </button>
      )}

      <div style={{ display: 'flex', gap: space[2] }}>
        {action.primaryCta && (
          <button
            onClick={() => onPrimary && onPrimary(action)}
            style={{
              flex: 1,
              padding: `${space[2]}px ${space[3]}px`,
              background: colors.brand,
              color: '#fff',
              border: 'none',
              borderRadius: radius.sm,
              ...type.small,
              fontWeight: 600,
              fontFamily: 'inherit',
              cursor: 'pointer',
              transition: `background ${motion.fast}`,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = colors.brandHover; }}
            onMouseLeave={e => { e.currentTarget.style.background = colors.brand; }}
          >
            {action.primaryCta.label}
          </button>
        )}
        {action.secondaryCta && (
          <button
            onClick={() => onSecondary && onSecondary(action)}
            style={{
              padding: `${space[2]}px ${space[3]}px`,
              background: colors.surface,
              color: colors.textSecondary,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.sm,
              ...type.small,
              fontWeight: 600,
              fontFamily: 'inherit',
              cursor: 'pointer',
            }}
          >
            {action.secondaryCta.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default NextBestActionCard;
